var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOwerviewMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7720_6786)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.94397 1.61992C6.09123 1.95738 5.93705 2.35032 5.59959 2.49758C4.70132 2.88957 3.91275 3.49564 3.30282 4.2628C2.69289 5.02996 2.28017 5.93485 2.10075 6.89836C1.92133 7.86188 1.98066 8.85467 2.27357 9.78995C2.56648 10.7252 3.08404 11.5745 3.781 12.2636C4.47797 12.9526 5.33311 13.4605 6.27168 13.7427C7.21025 14.0249 8.20365 14.0729 9.16505 13.8825C10.1265 13.692 11.0266 13.269 11.7867 12.6504C12.5469 12.0317 13.1439 11.2363 13.5256 10.3336C13.669 9.99447 14.0601 9.8358 14.3993 9.9792C14.7384 10.1226 14.897 10.5138 14.7536 10.8529C14.2871 11.9562 13.5574 12.9284 12.6284 13.6845C11.6993 14.4406 10.5991 14.9577 9.4241 15.1904C8.24905 15.4231 7.03489 15.3644 5.88775 15.0195C4.74062 14.6746 3.69544 14.0539 2.84359 13.2118C1.99175 12.3696 1.35917 11.3316 1.00118 10.1884C0.643179 9.04531 0.570656 7.8319 0.78995 6.65427C1.00924 5.47665 1.51367 4.37067 2.25915 3.43303C3.00462 2.49539 3.96843 1.75464 5.06631 1.27554C5.40377 1.12828 5.79671 1.28246 5.94397 1.61992Z",
    fill: "#7E716D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.52925 0.862254C7.65427 0.73723 7.82384 0.666992 8.00065 0.666992C8.96368 0.666992 9.91728 0.856675 10.807 1.22521C11.6967 1.59374 12.5051 2.13391 13.1861 2.81488C13.8671 3.49584 14.4072 4.30426 14.7758 5.19398C15.1443 6.0837 15.334 7.0373 15.334 8.00033C15.334 8.36852 15.0355 8.66699 14.6673 8.66699H8.00065C7.63246 8.66699 7.33398 8.36852 7.33398 8.00033V1.33366C7.33398 1.15685 7.40422 0.987279 7.52925 0.862254ZM8.66732 2.03748V7.33366H13.9635C13.901 6.7746 13.7601 6.22599 13.5439 5.70422C13.2424 4.97627 12.8004 4.31484 12.2433 3.75768C11.6861 3.20053 11.0247 2.75858 10.2968 2.45705C9.77499 2.24093 9.22638 2.09998 8.66732 2.03748Z",
    fill: "#7E716D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwerviewMenuIcon);
export default __webpack_public_path__ + "static/media/owerview-menu-icon.467ed01f0cc583beb48e5334283e7f45.svg";
export { ForwardRef as ReactComponent };